<template>
  <button
    :class="[
      'rounded-button',
      `rounded-button--${size}`
    ]"
    @click="buttonAction"
  >
    <span class="rounded-button__bg" />
    <p>{{ content }}</p>
  </button>
</template>

<script>
import audio from '../scripts/audio';

export default {
  name: 'RoundedButton',

  props: {
    action: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: false,
      default: 'small',
    },
  },

  methods: {
    buttonAction() {
      audio.play('click');

      switch (true) {
        case this.action === 'selectCharacter':
          audio.play('background-intro');
          this.$store.commit('SET_CHARACTER_SELECTION', true);
          this.$game.goToCharSelection();
          this.$sendEvent('Start', 'start');
          break;

        case this.action === 'startPlaying':
          this.$store.commit('SET_INTRO_DONE', true);
          this.$store.commit('SET_PLAY_GAME', false);
          this.$store.commit('SET_GAME_LOADING', true);
          this.$sendEvent('Bloom!', `character_choice_${this.$store.state.characterId}`);
          this.$game.setUpGame().then(() => {
            this.$store.commit('SET_GAME_LOADING', false);
            this.$game.startPlaying().then(() => {
              audio.stop('background-intro');
              this.$eventHub.$emit('play-pause');
              if (this.$store.state.tutorial < 3) this.$store.commit('SET_TUTORIAL', 0);
              else this.$game.startSpawning();
            });
          });
          break;

        case this.action === 'resumeGame':
          this.$eventHub.$emit('play-pause');
          break;

        case this.action === 'leaveGame':
          this.$store.commit('SET_SHOW_PAUSE', false);
          audio.play('background-intro');
          this.$game.backToCharSelection().then(() => {
            this.$store.commit('SET_SHOW_PAUSE', true);
            this.$store.commit('SET_INTRO_DONE', false);
          });
          break;

        case this.action === 'playAgain':
          this.$store.commit('SET_GAMEOVER', false);
          this.$store.commit('SET_SHOW_PAUSE', false);
          this.$sendEvent('Start', 'start_replay');
          this.$game.backToCharSelection().then(() => {
            this.$store.commit('SET_SHOW_PAUSE', true);
            this.$store.commit('SET_INTRO_DONE', false);
          });
          break;

        case this.action === 'closeTutorial':
          this.$store.commit('SET_TUTORIAL', 3);
          this.$game.startSpawning();
          break;

        default:
          console.log('NO_ACTION_FOUND');
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rounded-button {
  position: relative;
  width: 150px;
  height: 50px;
  line-height: 50px;

  background-color: transparent;

  text-align: center;
  // font-weight: 800;
  font-size: 18px;

  cursor: pointer;

  &.rounded-button--big {
    width: 180px;
  }

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-color: $gold;
    border-radius: 100px;
    box-shadow: $button-shadow;

    @extend %grain;
  }

  p {
    display: block;
    position: relative;
  }

  @include mq(ipadP, $and: $is-not-touch-device) {
    .rounded-button,
    &.rounded-button--big {
      width: 240px;
      height: 60px;
      line-height: 60px;
    }
  }

  @include mq($and: $is-not-touch-device) {
    &__bg {
      transition: transform 0.5s $bloom;
    }
    &:hover &__bg {
      transform: scale(1.1);
    }
  }
}
</style>
